import React from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  const navLinks = ['Home', 'Services', 'About', 'FAQ', 'Reviews', 'Contact'];
  return <footer style={{
    backgroundColor: '#0F1B33'
  }} aria-label="Site footer" data-id="element-9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-10">
        {/* 3-column grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center md:text-left" data-id="element-11">
          {/* Column 1: Logo + Description */}
          <div className="flex flex-col items-center md:items-start" data-id="element-12">
            <div className="flex items-center gap-1" data-id="element-13">
              <span className="font-bold text-xl text-white" data-id="element-14">
                Precise Transcripts
              </span>
              <span className="font-bold text-xl" style={{
              color: '#C8962E'
            }} data-id="element-15">
                {' '}
                LLC
              </span>
            </div>
            <p className="text-gray-400 text-sm mt-3 max-w-xs leading-relaxed" data-id="element-16">
              Your premier destination for precision transcription and
              translation services. Accuracy, security, and speed — every time.
            </p>
          </div>

          {/* Column 2: Quick Links */}
          <div className="flex flex-col items-center md:items-start" data-id="element-17">
            <h3 className="text-white font-semibold mb-4 text-base" data-id="element-18">
              Quick Links
            </h3>
            <nav aria-label="Footer navigation" data-id="element-19">
              {navLinks.map(link => <a key={link} href="#" className="block text-gray-400 text-sm mb-2 transition-colors duration-200" onMouseEnter={e => e.currentTarget.style.color = '#2DA5A0'} onMouseLeave={e => e.currentTarget.style.color = '#9ca3af'} data-id="element-20">
                  {link}
                </a>)}
            </nav>
          </div>

          {/* Column 3: Contact Info */}
          <div className="flex flex-col items-center md:items-start" data-id="element-21">
            <h3 className="text-white font-semibold mb-4 text-base" data-id="element-22">
              Contact Us
            </h3>
            <div className="flex flex-col gap-3" data-id="element-23">
              <a href="tel:+12016778496" className="flex items-start gap-2 text-gray-400 text-sm hover:text-gray-200 transition-colors" data-id="element-24">
                <PhoneIcon className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                color: '#2DA5A0'
              }} aria-hidden="true" data-id="element-25" />
                <span data-id="element-26">+1 (201) 677-8496</span>
              </a>
              <a href="mailto:Info@precisetranscripts.com" className="flex items-start gap-2 text-gray-400 text-sm hover:text-gray-200 transition-colors" data-id="element-27">
                <MailIcon className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                color: '#2DA5A0'
              }} aria-hidden="true" data-id="element-28" />
                <span data-id="element-29">Info@precisetranscripts.com</span>
              </a>
              <div className="flex items-start gap-2 text-gray-400 text-sm" data-id="element-30">
                <MapPinIcon className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                color: '#2DA5A0'
              }} aria-hidden="true" data-id="element-31" />
                <span data-id="element-32">45 N Broad St, Ridgewood, NJ 07450</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-12 pt-6 text-center" data-id="element-33">
          <p className="text-gray-500 text-xs" data-id="element-34">
            © 2025 Precise Transcripts LLC. All rights reserved.
          </p>
          {/* Social Icons */}
          <div className="flex justify-center mt-3 gap-4" data-id="element-35">
            <a href="#" aria-label="Visit our Google Business page" className="text-gray-400 hover:text-gray-200 transition-colors" data-id="element-36">
              <GlobeIcon className="w-5 h-5" aria-hidden="true" data-id="element-37" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}